import { CookieRefreshService, FCC, JarvisCookieAuthProvider, useDynamicConfig } from "@dgs/core";

export const PersonalManagerAuthProvider: FCC = ({ children }) => {
	const { authUrl } = useDynamicConfig();

	return (
		<JarvisCookieAuthProvider authUrl={authUrl}>
			<CookieRefreshService />
			{children}
		</JarvisCookieAuthProvider>
	);
};
